// src/i18n/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

// Import tłumaczeń
import translationPL from "./locales/pl/translation.json";
import translationEN from "./locales/en/translation.json";

// Zasoby tłumaczeń
const resources = {
    pl: {
        translation: translationPL,
    },
    en: {
        translation: translationEN,
    },
};

// Konfiguracja i18next
i18n
    // Użycie backendu i detector'a języka
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "pl", // Domyślny język, gdy wykryty nie jest wspierany
        debug: process.env.NODE_ENV === "development",

        // Domyślny namespace
        defaultNS: "translation",

        // Zachowanie języka przy odświeżeniu
        detection: {
            order: ["localStorage", "navigator"],
            lookupLocalStorage: "i18nextLng",
            caches: ["localStorage"],
        },

        interpolation: {
            escapeValue: false, // React już zabezpiecza przed XSS
        },

        react: {
            useSuspense: true,
        },
    });

// Eksportujemy funkcję zmiany języka
export const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
    // Zapisz wybór w localStorage
    localStorage.setItem("i18nextLng", language);
};

// Eksport skonfigurowanej instancji i18n
export default i18n;
